import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry, Sentry } from '../../shared/src/sentry';
import App from './App';
import './index.css';

initSentry('webapp-admin');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
